<template>
  <div class="table-responsive">
    <table class="table table-hover">
      <thead>
      <tr>
        <th colspan="5">
          <div class="col-4 col-sm-3 col-md-2 float-sm-right mx-0 px-0">
            <select class="custom-select custom-select-sm " v-model="selected" @change="paginar">
              <option selected>Mostrar</option>
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="100000">Todos</option>
            </select>
          </div>
        </th>
      </tr>
      <tr>
        <th>Contenido</th>
        <th>Etiquetas</th>
        <th>Posición</th>
        <th>Categoria</th>
        <th class="text-center">Acciones</th>
      </tr>
      </thead>
      <tbody>
      <tr class="tr-contenido" v-for="contenido in contenidos.data">
        <td class="py-1 my-1 td-titulo">{{contenido.titulo}}</td>
        <td class="py-1 my-1 td-slug"><span v-for="etiqueta in contenido.etiquetas">{{ etiqueta.etiqueta }}, </span></td>
        <td class="py-1 my-1">
          <button type="submit" class="btn btn-secondary btn-sm btn-outline-success py-0"
                  v-if="visibilidadposicion != contenido.id" title="Editar posición"
                  @click="editarPosicion(contenido)">{{ contenido.orden }}
          </button>
          <div class="input-group" v-else>
            <div class="input-group-prepend">
              <button class="btn btn-outline-danger btn-sm  py-0 px-1" type="submit" title="Cancelar"
                      @click="cancelarPosicion(contenido)">
                <i class="far fa-times-circle"></i></button>
            </div>
            <input type="number" min="0" class="py-1 input-group-sm" placeholder="0" aria-label=""
                   aria-describedby="basic-addon1"
                   style="height: 21px; width: 40px" data-toggle="tooltip" data-placement="bottom"
                   title="Agregue la posición" :onmouseover="tooltop()" v-model="contenido.orden">
            <div class="input-group-prepend">
              <button class="btn btn-outline-primary btn-sm  py-0 px-1" type="submit" title="Guardar"
                      @click="guardarPosicion(contenido)"><i class="far fa-save"></i>
              </button>
            </div>
          </div>
        </td>
        <td class="py-1 my-1 td-categoria">{{contenido.categoria}}</td>
        <td class="py-1 my-1 text-center td-botonAcciones">
          <a :href="'/' + cliente.slug + '/'+contenido.categoria_slug+ '/'+ contenido.slug " target="_blank">
            <i class="fas fa-eye botonAcciones text-info" data-toggle="tooltip"
               data-placement="left" title="Ver" :onmouseover="tooltop()"></i>
          </a>
          <i class="far fa-edit botonAcciones text-warning   mx-2" data-toggle="tooltip"
             data-placement="left" title="Editar" :onmouseover="tooltop()" @click="editarContenido(contenido)"></i>
          <i class="far fa-trash-alt botonAcciones text-danger" data-toggle="tooltip"
             data-placement="left" title="Eliminar" :onmouseover="tooltop()" @click="eliminarContenido(contenido)"></i>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="btn-toolbar d-flex justify-content-center" role="toolbar" aria-label="Toolbar with button groups">
      <div class="btn-group mr-2" role="group" aria-label="First group">
        <button type="button" :class="{'disabled':paginacion.anterior,'btn btn-secondary':true}"
                @click="cargarContenidos({page: contenidos.current_page - 1})">
          <i class="fas fa-arrow-left"></i> Atrás
        </button>
        <button type="button" :class="{disabled:paginacion.siguiente,'btn btn-secondary':true}"
                @click="cargarContenidos({page: contenidos.current_page + 1})">
          Siguiente<i class="fas fa-arrow-right"></i></button>
      </div>
    </div>

  </div>
</template>

<script>
  import servicioApi from '../../../servicioApi';

  export default {
    name: "listarContenido",
    data() {
      return {
        contenidos: {},
        cliente: {},
        selected: 'Mostrar',
        paginacionParametros: {page: '', mostrar: ''},
        paginacion: {anterior: false, siguiente: false},
        visibilidadposicion: '',
        position: '',

      }
    },
    beforeCreate() {
      this.paginacion = {anterior: false, siguiente: false};

      let self = this;
      EventBus.$on('listaContenidos', function (data) {
        self.contenidos = data.contenidos;
        self.cliente = data.cliente;
        if (self.contenidos.current_page == 1)
          self.paginacion.anterior = true;
        else
          self.paginacion.anterior = false;

        if (self.contenidos.last_page == self.contenidos.current_page)
          self.paginacion.siguiente = true;
        else
          self.paginacion.siguiente = false;
      });
    },
    mounted() {
      EventBus.$on('cargarContenidos', data => {
        if (data) {
          this.paginacionParametros.guardarContenido = true;
          this.cargarContenidos({page: '1', mostrar: 'Mostrar'});
        }
      });
    },
    methods: {
      editarPosicion(data) {
        console.log(data);
        this.visibilidadposicion = data.id;
        this.position = data.orden;
        console.log(this.visibilidadposicion)
      },
      guardarPosicion(data) {
        console.log(data);
        if (data.etiquetas == '')
          data.etiquetas = "null";
        console.log(data)
        servicioApi.rol_regular.contenidos.putContenidos(data).then(resp => {
          this.visibilidadposicion = '';
          this.cargarContenidos(this.paginacionParametros);
        });
      },
      cancelarPosicion(data) {
        console.log(data);
        this.visibilidadposicion = '';
        data.orden = this.position;
        console.log(this.visibilidadposicion)
      },
      tooltop() {
        $(function () {
          $('[data-toggle="tooltip"]').tooltip();
        })
      },
      cargarContenidos: function (data) {
        if (data.page > this.contenidos.last_page || data.page < 1 && !data.eliminar) {
          data.page = this.contenidos.last_page;
        }
        else {
          if (this.selected != 'Mostrar')
            data.mostrar = this.selected;
          else
            data.mostrar = 10;
          this.paginacionParametros = data;
          servicioApi.rol_regular.contenidos.getContenidos(data).then(resp => {
            this.contenidos = resp.data.data.contenidos;
            this.cliente = resp.data.data.cliente;
            if (this.contenidos.current_page == 1)
              this.paginacion.anterior = true;
            else
              this.paginacion.anterior = false;

            if (this.contenidos.last_page == this.contenidos.current_page)
              this.paginacion.siguiente = true;
            else
              this.paginacion.siguiente = false;
          }).catch(e => {
          });
        }
      },
      eliminarContenido: function (data) {
        servicioApi.rol_regular.contenidos.deleteContenidos(data.id).then(resp => {
          this.paginacionParametros.eliminar = true;
          this.cargarContenidos(this.paginacionParametros);
        }).catch(e => {
        });
      },
      editarContenido: function (data) {
        EventBus.$emit('editarContenido', data);
      },
      paginar: function () {
        if (this.selected != 'Mostrar') {
          this.cargarContenidos({mostrar: this.selected});
        } else
          this.cargarContenidos({mostrar: 10});
      }
    }
  }
</script>

<style scoped lang="scss">
  .tr-contenido {
    & .td-titulo {
      min-width: 250px;
    }
    & .td-slug {
      min-width: 250px;
    }
    & .td-categoria {
      min-width: 150px;
    }
    & .td-botonAcciones {
      min-width: 105px;
    }
  }

  .botonAcciones {
    cursor: pointer;
    padding: 2px;
    background-size: 8px 10px;
    /*border: 1px solid rgba(0, 0, 0, .26);*/
    border-radius: .125rem;
    -webkit-appearance: none;

    /*border-color: rgba(0, 0, 0, 0.15);*/
    -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, .075), 0 0 5px rgba(23, 255, 233, 0);
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, .075), 0 0 5px rgba(23, 255, 233, 0);
    &.ver {
      /*background-color: #5bc0de;*/
      border-color: rgb(70, 184, 255);
      /*color: #ffffff !important;*/
    }
    &.editar {
      border-color: #f0ad4e;
    }
    &.eliminar {
      border-color: #f00e37;
    }
  }

  .custom-select:focus {
    background-size: 8px 10px;
    border: 1px solid rgba(0, 0, 0, .26);
    border-radius: .125rem;
    -webkit-appearance: none;

    border-color: rgba(0, 0, 0, .26);
    -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, .075), 0 0 5px rgba(23, 255, 233, 0);
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, .075), 0 0 5px rgba(23, 255, 233, 0);
  }
</style>



// WEBPACK FOOTER //
// src/components/privada/regular/contenido/componentes/listarContenido.vue